import * as React from 'react';
import { FC } from 'react';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { ModalSize } from 'components/modal';

import { ConfirmRestaurantMap } from './confirm-restaurant-map';
import {
  Address,
  ButtonContainer,
  Details,
  MapContainer,
  P,
  StyledModal,
  Title,
  Wrapper,
} from './modal-confirm-restaurant-desktop.styled';
import { IModalConfirmRestaurantViewProps } from './types';

export const ModalConfirmRestaurantDesktopView: FC<IModalConfirmRestaurantViewProps> = ({
  address,
  changeText,
  city,
  confirmText,
  distanceText,
  handleChangeRestaurant,
  handleConfirmRestaurant,
  lat,
  lng,
  stateProvince,
  yourClosestStore,
}) => (
  <StyledModal
    size={ModalSize.SMALL}
    onDismiss={() => handleConfirmRestaurant(false)}
    mParticleEventData={{
      modalAppearanceEventMessage: 'Confirm auto-selected restaurant modal',
    }}
    data-testid="modal-confirm-restaurant-desktop"
  >
    <Wrapper>
      <Title id="modal-heading">{yourClosestStore}</Title>
      <Address>{address}</Address>
      <Details>
        <P>
          {city}, {stateProvince}
        </P>
        <P>{distanceText}</P>
      </Details>
      <MapContainer>
        <ConfirmRestaurantMap lat={lat} lng={lng} />
      </MapContainer>
      <ButtonContainer>
        <ActionButton
          size={ActionButtonSizes.SMALL}
          variant={ActionButtonVariants.OUTLINE}
          data-testid="change-button"
          onClick={handleChangeRestaurant}
        >
          {changeText}
        </ActionButton>
        <ActionButton
          size={ActionButtonSizes.SMALL}
          data-testid="confirm-button"
          onClick={() => handleConfirmRestaurant(true)}
        >
          {confirmText}
        </ActionButton>
      </ButtonContainer>
    </Wrapper>
  </StyledModal>
);
